module.exports = __webpack_public_path__ + "static/media/spotify.0d4ac5a5.svg";